// extracted by mini-css-extract-plugin
export var footer = "_nk-5";
export var fulfillmentInput = "_nk-0";
export var shipDateInput = "_nk-1";
export var shipmentModal = "_nk-2";
export var shipmentModalContent = "_nk-3";
export var tableContainer = "_nk-4";